import { mutator } from 'satcheljs';
import { setNotificationPanelTriggered } from '../actions';
import { getStore } from '../store/store';

mutator(setNotificationPanelTriggered, (msg) => {
  getStore().isNotificationPanelTrigerred = msg.isTrigerred;
});
